module.exports = "<ul class=\"pagination margin-10\"> <li class=\"paginate_button previous\" :class=\"{'disabled': model.page() == 1}\"> <a href=javascript:; @click=previous()>Anterior</a></li> <li class=paginate_button v-for=\"p in model.pages()\" :class=\"{'active': model.page() == p}\"> <a href=javascript:; @click=toPage(p)>{{ p }}</a> </li> <li class=\"paginate_button next\" :class=\"{'disabled': model.page() == model.pageCount()}\"> <a href=javascript:; @click=next()>Próxima</a> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/pagination.html
// module id = 1691
// module chunks = 1